import { render, staticRenderFns } from "./MarketingAutomationFormPanelSection.vue?vue&type=template&id=1b78b76d&scoped=true"
import script from "./MarketingAutomationFormPanelSection.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationFormPanelSection.vue?vue&type=script&lang=js"
import style0 from "./MarketingAutomationFormPanelSection.vue?vue&type=style&index=0&id=1b78b76d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b78b76d",
  null
  
)

export default component.exports